import BaseModelInstance from './base.model'
import { PerformanceRecord as ModelDefinition } from './model-definitions'

class PerformanceRecord extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default PerformanceRecord
